import {useMediaQuery} from '@mui/material'
import {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {CookiesAccept} from 'features/cookiesAccept'
import {useCanonicalLink, useMetaDescription, useTitle} from 'shared/lib/meta'
import {MARKETING_LOCAL_STORAGE_KEY} from 'shared/mirrors/config'
import {text} from 'shared/mirrors/text'
import styles from './styles.module.scss'
import {
  CreateAccountSection,
  CreateAccountSectionMobile
} from './ui/createAccountSection'
import {CTASection} from './ui/ctaSection'
import {FooterSection} from './ui/footerSection'
import {GirlPreviewSection} from './ui/girlPreviewSection'
import {Header} from './ui/header'
import {SourceSection} from './ui/sourceSection'
import {UsefulSection} from './ui/usefulSection'

const HomePage: FC = () => {
  const location = useLocation()
  const isTablet = useMediaQuery(`(max-width: ${styles.isTablet})`)
  const isMobile = useMediaQuery(`(max-width: ${styles.isMobile})`)
  const [isVisibleHeader, setIsVisibleHeader] = useState<boolean>(!isTablet)

  useEffect(() => {
    if (location.pathname.includes('link')) return
    if (!location.search) {
      const item = localStorage.getItem(MARKETING_LOCAL_STORAGE_KEY)
      if (!item) return

      return localStorage.removeItem(MARKETING_LOCAL_STORAGE_KEY)
    }

    localStorage.setItem(MARKETING_LOCAL_STORAGE_KEY, location.search)
  }, [])

  useEffect(() => {
    setIsVisibleHeader(!isTablet)
  }, [isTablet])

  useTitle(
    `${text.main.siteName} - Social communication network ❤️. Explore emotions & meet people online`
  )

  useMetaDescription(
    'Free Dating website for singles ❤️ Find new friends with interests and hobbies 🤩 Find real love. Free registration and bonuses. Find a Match Online 🥰 No card - join and start surfing free now'
  )

  useCanonicalLink(`https://${window.location.hostname}`)

  return (
    <div className={styles.home}>
      <Header isShow={isVisibleHeader} setIsShow={setIsVisibleHeader} />
      {isMobile ?
        <CreateAccountSectionMobile />
        :
        <CreateAccountSection
          className={isVisibleHeader ? styles.padding : undefined}
        />
      }
      <GirlPreviewSection />
      <UsefulSection />
      <SourceSection />
      <CTASection />
      <FooterSection />
      <CookiesAccept />
    </div>
  )
}

export default HomePage
